import { Component, DestroyRef, effect, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'login-error',
  styleUrls: ['./login-error.component.scss'],
  templateUrl: './login-error.component.html'
})
export class LoginErrorComponent implements OnInit {
  
  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _destroyRef = inject(DestroyRef);
  private readonly _translateService = inject(TranslateService);
  
  private readonly errorCode = signal<string>(null);
  protected errorTitle: string = '';
  protected errorMessage: string = '';
  
  constructor() {
    effect(() => {
      if (this.errorCode() !== null) {
        this.errorTitle = this._translateService.instant(`LOGIN_ERROR.ERRORS.${this.errorCode()}.TITLE`);
        this.errorMessage = this._translateService.instant(`LOGIN_ERROR.ERRORS.${this.errorCode()}.MESSAGE`);
      }
    });
  }
  
  ngOnInit(): void {
    // Récupère le query param "error" de l'URL
    this._activatedRoute.queryParamMap
    .pipe(takeUntilDestroyed(this._destroyRef))
    .subscribe(params => {
      this.errorCode.set(params.get('error'));
    });
  }
}
